/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { DriftReportsPage } from '@/pages/Reports/DriftReportsPage';

export function ReportsRoute() {
  return <DriftReportsPage />;
}
